/// <amd-module name="TFS/CreateProject/Components/ProjectNameTextField" />
import * as React from "react";
import { ProjectParameterConstants } from "TFS/CreateProject/Constants";
import { StatusValueType } from "TFS/CreateProject/Contracts";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import { getId } from "VSS/Core/Util/Object";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { FormItem } from "VSSUI/FormItem";
import { TextField } from "VSSUI/TextField";

export interface IProjectNameTextFieldProps extends IVssComponentProperties {
    onProjectNameTextFieldKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    value: string;
    disabled: boolean;
    projectNameStatus: StatusValueType;
    projectCreationStatus: StatusValueType;
    onInputChange: (newValue: string) => string;
    errorMessage: string;
}

export class ProjectNameTextField extends VssComponent<IProjectNameTextFieldProps, {}> {
    private _projectNameTextFieldId: string;
    private _projectNameAriaDescriptionId: string;
    private _textField: React.RefObject<TextField> = React.createRef();

    constructor(props: IProjectNameTextFieldProps, context: IVssComponentContext) {
        super(props, context);

        this._projectNameTextFieldId = getId("project-name-textfield");
        this._projectNameAriaDescriptionId = getId("project-name-aria-description");
    }

    public render(): JSX.Element {
        return (
            <div className="project-name-container">
                <FormItem required={true} message={this.props.errorMessage} error={this.props.errorMessage !== ""} label={CreateProjectResources.CreateProjectNameContainerHeader}>
                    <TextField
                        autoFocus={true}
                        key={this._projectNameTextFieldId}
                        ariaDescribedBy={this._projectNameAriaDescriptionId}
                        className="project-name-textfield"
                        inputClassName="project-name-textfield-input"
                        onKeyDown={this.props.onProjectNameTextFieldKeyDown}
                        disabled={this.props.disabled}
                        maxLength={ProjectParameterConstants.MaxProjectNameLength}
                        value={this.props.value}
                        onChange={(e, newValue) => this.props.onInputChange(newValue)}
                        ref={this._textField}
                    />
                </FormItem>
                <div className="hidden" id={this._projectNameAriaDescriptionId}>
                    {CreateProjectResources.CreateProjectNameAriaDescription}
                </div>
            </div>
        );
    }

    public focus() {
        if (this._textField.current) {
            this._textField.current.focus();
        }
    }

    public readonly select = () => {
        if (this._textField.current) {
            this._textField.current.select();
        }
    };
}
